import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';

const groups = [
  {
    key: 'preventive',
    title: 'Preventive Care',
    intro: 'Everyday care that keeps your pet healthy for the long run.',
    slug: 'wellness-care',
    icon: 'ri-heart-pulse-line',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20calm%20veterinarian%20gently%20listening%20with%20stethoscope%20to%20a%20medium%20mixed%20breed%20dog%20on%20a%20warm%20exam%20table%20in%20a%20bright%20modern%20warm%20veterinary%20clinic%20with%20natural%20daylight%2C%20warm%20off%20white%20background%2C%20intimate%20real%20wellness%20moment%2C%20natural%20skin%20tones&width=720&height=540&seq=svc-pg-preventive&orientation=landscape',
    items: [
      { name: 'Annual wellness exam', desc: 'A full head-to-tail exam with plenty of time for questions.' },
      { name: 'Vaccinations', desc: 'Core and lifestyle-based vaccines tailored to your pet.' },
      { name: 'Parasite prevention', desc: 'Year-round flea, tick and heartworm plans.' },
      { name: 'Nutrition & weight', desc: 'Practical guidance you can actually stick to.' },
    ],
  },
  {
    key: 'diagnostics',
    title: 'Diagnostics',
    intro: 'Answers you can trust, most of them the same day.',
    slug: 'diagnostics',
    icon: 'ri-microscope-line',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20veterinarian%20reviewing%20a%20digital%20xray%20on%20a%20monitor%20in%20a%20bright%20modern%20warm%20veterinary%20clinic%20with%20soft%20natural%20daylight%2C%20calm%20focused%20professional%20moment%2C%20off%20white%20background%2C%20real%20clinical%20environment&width=720&height=540&seq=svc-pg-diag&orientation=landscape',
    items: [
      { name: 'In-house bloodwork', desc: 'CBC, chemistry, thyroid and more, often within the hour.' },
      { name: 'Digital radiography', desc: 'Low-dose, high-resolution imaging.' },
      { name: 'Ultrasound', desc: 'For soft tissue and abdominal evaluation.' },
      { name: 'Urinalysis & cytology', desc: 'Quick microscopy in our clinic lab.' },
    ],
  },
  {
    key: 'dental',
    title: 'Dental',
    intro: 'Comfortable, thorough dentistry with modern imaging.',
    slug: 'dental-care',
    icon: 'ri-shield-cross-line',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20veterinary%20professional%20carefully%20checking%20the%20teeth%20of%20a%20medium%20dog%20in%20a%20bright%20clean%20modern%20veterinary%20clinic%20with%20soft%20natural%20daylight%2C%20warm%20off%20white%20wall%20background%2C%20gentle%20human%20animal%20interaction%2C%20real%20dental%20care%20moment&width=720&height=540&seq=svc-pg-dental&orientation=landscape',
    items: [
      { name: 'Oral exam & charting', desc: 'Every tooth checked, documented and photographed.' },
      { name: 'Cleaning under anesthesia', desc: 'Monitored, warmed, and gentle.' },
      { name: 'Dental radiographs', desc: 'See what a visual exam alone cannot.' },
      { name: 'Extractions', desc: 'Only when necessary, with careful pain management.' },
    ],
  },
  {
    key: 'surgery',
    title: 'Surgery',
    intro: 'Soft tissue procedures with attentive recovery care.',
    slug: 'surgery',
    icon: 'ri-first-aid-kit-line',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20small%20dog%20resting%20comfortably%20on%20a%20warm%20blanket%20in%20a%20recovery%20area%20of%20a%20bright%20modern%20veterinary%20clinic%20with%20soft%20natural%20daylight%2C%20quiet%20calm%20post%20operative%20care%20scene%2C%20warm%20off%20white%20background%2C%20real%20clinic%20setting&width=720&height=540&seq=svc-pg-surgery&orientation=landscape',
    items: [
      { name: 'Spay & neuter', desc: 'Standard-of-care surgical protocols.' },
      { name: 'Mass removals', desc: 'Biopsy submission and clear follow-up.' },
      { name: 'Soft tissue surgery', desc: 'From lacerations to abdominal procedures.' },
      { name: 'Post-op care', desc: 'Written plans and a next-day check-in.' },
    ],
  },
  {
    key: 'urgent',
    title: 'Illness & Urgent Care',
    intro: "Same-day help when your pet just isn't right.",
    slug: 'urgent-care',
    icon: 'ri-alarm-warning-line',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20calm%20veterinarian%20gently%20holding%20and%20comforting%20a%20small%20mixed%20breed%20dog%20in%20a%20bright%20warm%20modern%20veterinary%20exam%20room%20with%20natural%20daylight%2C%20warm%20off%20white%20background%2C%20quiet%20same%20day%20care%20moment%2C%20natural%20skin%20tones&width=720&height=540&seq=svc-pg-urgent&orientation=landscape',
    items: [
      { name: 'Same-day sick visits', desc: 'Daily slots reserved for urgent needs.' },
      { name: 'GI & vomiting', desc: 'Rapid triage and comfort care.' },
      { name: 'Skin & ear infections', desc: 'Get relief started quickly.' },
      { name: 'Emergency coordination', desc: 'We help you find the right level of care after hours.' },
    ],
  },
];

const shapes = ['shape-1', 'shape-2', 'shape-3', 'shape-4', 'shape-5'];

export default function Services() {
  return (
    <Layout>
      <section className="relative overflow-hidden pt-24 md:pt-32 pb-20 md:pb-28" style={{ background: '#F2D16B' }}>
        <span className="deco-float-lg absolute pointer-events-none hidden md:block" style={{ width: 620, height: 620, top: -240, right: -180, background: '#F8E4A8', borderRadius: '58% 42% 63% 37% / 47% 55% 45% 53%' }} aria-hidden />
        <div className="relative max-w-container mx-auto px-5 md:px-12">
          <div className="max-w-editorial">
            <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-cocoa">Services</div>
            <h1 className="mt-3 font-display font-bold text-[52px] md:text-[76px] leading-[0.98] text-cocoa">
              Care for every stage of your pet's life.
            </h1>
            <p className="mt-6 text-[18px] text-ink/80 leading-relaxed max-w-text">
              A modern general practice with the diagnostics, dentistry and surgical care most pets need — under one warm, unhurried roof.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-container mx-auto px-5 md:px-12 space-y-10 md:space-y-12">
          {groups.map((g, gi) => {
            const flip = gi % 2 === 1;
            return (
              <div
                key={g.key}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center rounded-[36px] border border-line p-6 md:p-10 ${gi % 2 === 0 ? 'bg-warm' : 'bg-white'}`}
              >
                <div className={`lg:col-span-5 ${flip ? 'lg:order-2' : ''}`}>
                  <div className={`img-hover relative w-full aspect-[5/4] bg-line ${shapes[gi % shapes.length]}`}>
                    <img src={g.img} alt={g.title} className="absolute inset-0 w-full h-full object-cover object-center" />
                  </div>
                </div>
                <div className={`lg:col-span-7 ${flip ? 'lg:order-1' : ''}`}>
                  <div className="flex items-center gap-4">
                    <span className="w-12 h-12 rounded-full bg-yellow flex items-center justify-center text-cocoa">
                      <i className={`${g.icon} text-[22px]`}></i>
                    </span>
                    <div className="text-[12px] font-semibold tracking-[0.14em] uppercase text-muted">{String(gi + 1).padStart(2, '0')} · {g.title}</div>
                  </div>
                  <h2 className="mt-5 font-display font-bold text-[34px] md:text-[44px] leading-[1.02] text-cocoa">{g.title}</h2>
                  <p className="mt-4 text-[16px] text-ink/75 leading-relaxed max-w-[520px]">{g.intro}</p>

                  <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {g.items.map(it => (
                      <li key={it.name} className="rounded-[18px] bg-white border border-line px-4 py-3">
                        <div className="text-[14px] font-semibold text-cocoa">{it.name}</div>
                        <div className="mt-1 text-[13px] text-ink/70 leading-relaxed">{it.desc}</div>
                      </li>
                    ))}
                  </ul>

                  <Link to={`/services/${g.slug}`} className="group mt-7 inline-flex items-center gap-2 text-[15px] font-semibold text-cocoa hover:text-careDark cursor-pointer transition-colors duration-200">
                    Learn more
                    <i className="link-arrow-icon ri-arrow-right-line text-[16px]"></i>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="pb-24 md:pb-32 bg-white">
        <div className="max-w-container mx-auto px-5 md:px-12">
          <div className="rounded-[36px] p-10 md:p-16 flex flex-col md:flex-row md:items-center md:justify-between gap-6" style={{ background: '#F2D16B' }}>
            <div>
              <h2 className="font-display font-bold text-[30px] md:text-[40px] leading-[1.05] text-cocoa">Not sure which visit is right?</h2>
              <p className="mt-3 text-ink/80 text-[16px] max-w-[520px]">Tell us what's going on. Our team will help you pick the right appointment for your pet.</p>
            </div>
            <Link to="/book" className="btn-motion group inline-flex items-center gap-2 h-[54px] px-8 rounded-full bg-cocoa hover:bg-careDark text-white text-[15px] font-semibold cursor-pointer whitespace-nowrap">
              Book an Appointment
              <i className="link-arrow-icon ri-arrow-right-line text-[16px]"></i>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}